import request from "@/utils/request";

// 查询意见反馈列表
export const getUserFeedbackInfo = (params) => {
  return request({
    url: "/we_chat/feedback/getUserFeedbackInfo",
    method: "get",
    params,
  });
};

// 新增意见反馈
export const feedbackAdd = (data) => {
  return request({
    url: "/we_chat/feedback/add",
    method: "post",
    data,
  });
};

// 查询意见反馈详细
export const feedback = (id) => {
  return request({
    url: `/we_chat/feedback/${id}`,
    method: "get",
  });
};
